import Signin from "../../authentication/components/Signin";
import axios from "../../../common/utils/axios";
import {
    REMOVE_KIT_FROM_CART,
    SWITCH_CART_DIALOG,
    ADD_KIT_TO_CART,
    GET_CART_KITS,
    ADD_KITS_TO_CART,
    UPDATE_STEPPER,
    GET_DELIVERY_COST,
    UPDATE_DELIVERY_COST,
    UPDATE_DISCOUNT,
    UPDATE_DELIVERY_METHOD,
    UPDATE_ORDER_DELIVERY_ADDRESS,
    GET_DELIVERY_METHODS,
    REDIRECT_TO_PAYMENT,
    CREATE_STRIPE_SESSION,
    CREATE_ORDER,
    VALIDATE_COUPON,
    UPDATE_ORDER_BILLING_ADDRESS,
    UPDATE_TRANSFER_INFO,
    UPDATE_ORDER_Id,
    EDIT_ORDER,
    CREATE_WIRETRANSFER_TRANSACTION,
    CREATE_STRIPE_TRANSACTION,
    HIDE_CART_DIALOG,
    GET_ORDER_BY_ID,
    SET_ORDER_EDIT_MODE,
    GET_PRICE_BREAKDOWN,
    CREATE_CREDIT_CARD,
    CREATE_DEPOSIT,
    CREATE_WIRE_PAYMENT,
    CREATE_CARD_PAYMENT,
    EDIT_ALL_ORDER_DETAILS,
    GET_LATEST_ORDER,
    GET_DASHBOARD_ORDER_BY_ID,
    UPDATE_IS_BILLING,
    UPDATE_STATUS,
    UPDATE_INSURANCE_PERCENTAGE,
    GET_BILLING_COMPANY,
    UPDATE_SELLER_SHIPPING_LOGISTICS,
    GET_SELLER_SHIPPING_LOGISTICS,
} from "./actions";
import CartService from "../../../common/services/checkout/CartService";
import KitService from "../../../common/services/kit/KitService";
import CookieHelper from "../../../common/helpers/CookieHelper";
import CheckoutService from "../../../common/services/checkout/CheckoutService";
import DeliveryMethodService from "../../../common/services/checkout/DeliveryMethodService";
import StripeService from "../../../common/services/checkout/StripeService";
import TransactionService from "../../../common/services/checkout/TransactionService";
import GeneralHelper from "../../../common/helpers/GeneralHelper";
import { SHOW_TOAST_MESSAGE } from "../../../common/store/actions";
import GatewayService from "../../../common/services/checkout/GatewayService";


export default {
    state: {
        billingCompany:{},
        checkoutPaymentMode: 1,
        checkoutStockStep: 1,
        checkoutMarketplaceStep: 1,
        showCartDialog: false,
        FooterDisplay: true,
        HeaderBottomDisplay: true,
        cartdisplayActive: true,
        personnalInfoDisplayActive: false,
        deliveryAddressDisplayActive: false,
        deliveryMethodeDisplayActive: false,
        paymentDisplayActive: false,
        confirmationDisplayActive: false,
        checkoutActiveComponent: undefined,
        personnalInfoDisplay: true,
        deliveryAddressDisplay: true,
        deliveryMethodeDisplay: true,
        paymentDisplay: true,
        confirmation: true,
        FromNameDeliveryAddress: "Delivery Address",
        personnalInfoComponent: Signin,
        displaySummery: true,
        stepperDisplays: [1, 0, 0, 0, 0, 0],
        coupon: {
            value: undefined,
        },
        cart: {
            items: [],
            total: 0,
            detailedItems: [],
        },
        orderDiscount: 0,
        orderDeliveryCost: 0,
        orderEditMode: false,
        orderId: undefined,
        invoice_generated:0,
        payment_methods: [],
        delivery_methods: [],
        customer: null,
        orderDeliveryAddress: {
            vat_number:null,
            company_name:null,
            email:null,
            last_name:null,
            first_name:null,
            phone_dial:null,
            phone_number:null,
            address:null,
            zip:null,
            city:null,
            state:null,
            country:null,
        },
        orderBillingAddress: {
            vat_number:null,
            company_name:null,
            email:null,
            last_name:null,
            first_name:null,
            phone_dial:null,
            phone_number:null,
            address:null,
            zip:null,
            city:null,
            state:null,
            country:null,
        },
        orderDeliveryMethod: 2,
        orderTransferInfo: {},
        orderPaymentMethod: 1,
        deliveryAddressSelected: null,
        order: null,
        deposit_amount: null,
        deposit_paid: false,
        is_billing:false,
        status_id: 1,
        insurance_percentage:0,
        payment_method: 4,
        is_dashboard_order:false,
        wireTransferInfo:[{
            account_name:null,
		    iban:null,
            swift:null
        }],
    },
    getters: {
        billingCompany: (state) => {
            return state.billingCompany;
        },
        wireTransferInfo: (state) => {
            return state.wireTransferInfo;
        },
        is_dashboard_order: (state) => {
            return state.is_dashboard_order;
        },
        payment_method: (state) => {
            return state.payment_method;
        },
        orderId: (state) => {
            return state.orderId;
        },
        is_billing:(state)=>{
            return state.is_billing
        },
        insurance_percentage:(state)=>{
            return state.insurance_percentage
        },
        invoice_generated:(state)=>{
            return state.invoice_generated
        },
        status_id: (state)=>{
            return state.status_id
        },
        checkoutMarketplaceStep: (state) => {
            return state.checkoutMarketplaceStep;
        },
        checkoutPaymentMode: (state) => {
            return state.checkoutPaymentMode;
        },
        checkoutStockStep: (state) => {
            return state.checkoutStockStep;
        },
        orderEditMode: (state) => {
            return state.orderEditMode;
        },
        orderCoupon: (state) => {
            return state.coupon;
        },
        orderTotal: (state) => {
            var total = 0;
            state.cart.detailedItems.forEach(function(item) {
                total += parseInt(item.cprice);
            });
            total -= state.orderDiscount;
            total += state.orderDeliveryCost;
            return total;
        },
        orderDiscount: (state) => {
            return state.orderDiscount;
        },
        stepperDisplays: (state) => {
            return state.stepperDisplays;
        },
        orderDeliveryCost: (state) => {
            return state.orderDeliveryCost;
        },
        showCartDialog: (state) => {
            return state.showCartDialog;
        },

        deposit_amount: (state) => {
            return state.deposit_amount;
        },
        deposit_paid: (state) => {
            return state.deposit_paid;
        },
        countries: (state) => {
            return state.countries;
        },

        FooterDisplay: (state) => {
            return state.FooterDisplay;
        },
        cartKitsId: (state) => {
            return state.cartKitsId;
        },
        cartItems: (state) => {
            return state.cart.items;
        },
        detailedCartItems: (state) => {
            return state.cart.detailedItems;
        },
        summary: (state) => {
            return state.summary;
        },
        displaySummery: (state) => {
            return state.displaySummery;
        },
        personnalInfoComponent: (state) => {
            return state.personnalInfoComponent;
        },
        deliveryAddressDisplay: (state) => {
            return state.deliveryAddressDisplay;
        },
        paymentDisplay: (state) => {
            return state.paymentDisplay;
        },
        confirmation: (state) => {
            return state.confirmation;
        },
        deliveryMethodeDisplay: (state) => {
            return state.deliveryMethodeDisplay;
        },
        checkoutActiveComponent: (state) => {
            return state.checkoutActiveComponent;
        },
        checkoutActiveComponentName: (state) => {
            if (state.checkoutActiveComponent&&state.checkoutActiveComponent.name)
                return state.checkoutActiveComponent.name;
            else
                return null;
        },
        HeaderBottomDisplay: (state) => {
            return state.HeaderBottomDisplay;
        },
        cartdisplayActive: (state) => {
            return state.cartdisplayActive;
        },
        personnalInfoDisplayActive: (state) => {
            return state.personnalInfoDisplayActive;
        },
        deliveryAddressDisplayActive: (state) => {
            return state.deliveryAddressDisplayActive;
        },
        deliveryMethodeDisplayActive: (state) => {
            return state.deliveryMethodeDisplayActive;
        },
        paymentDisplayActive: (state) => {
            return state.paymentDisplayActive;
        },
        confirmationDisplayActive: (state) => {
            return state.confirmationDisplayActive;
        },
        personnalInfoDisplay: (state) => {
            return state.personnalInfoDisplay;
        },
        payment_methods: (state) => {
            return state.payment_methods;
        },
        delivery_methods: (state) => {
            return state.delivery_methods;
        },
        orderDeliveryMethod: (state) => {
            return state.orderDeliveryMethod;
        },
        orderDeliveryAddress: (state) => {
            return state.orderDeliveryAddress;
        },
        orderPaymentMethod: (state) => {
            return state.orderPaymentMethod;
        },
        orderTransferInfo: (state) => {
            return state.orderTransferInfo;
        },
        orderBillingAddress: (state) => {
            return state.orderBillingAddress;
        },
    },
    mutations: {
        wireTransferInfo(state, mode) {
            state.wireTransferInfo = mode;
        },
        update_is_dashboard_order(state, mode) {
            state.is_dashboard_order = mode;
        },
        updatePaymentMethod(state, mode) {
            state.payment_method = mode;
        },
        updateCheckoutMarketplaceStep(state, mode) {
            state.checkoutMarketplaceStep = mode;
        },
        updateCheckoutStockStep(state, mode) {
            state.checkoutStockStep = mode;
        },
        updatePaymentMode(state, mode) {
            state.checkoutPaymentMode = mode;
        },
        setStepperDisplays(state, mode) {
            state.stepperDisplays = mode;
        },
        [SET_ORDER_EDIT_MODE]: (state, mode) => {
            state.orderEditMode = mode;
        },
        deposit_paid(state, deposit_paid) {
            state.deposit_paid = deposit_paid;
        },
        deposit_amount(state, deposit_amount) {
            state.deposit_amount = deposit_amount;
        },

        deliveryAddress(state, deliveryAddress) {
            state.deliveryAddress = deliveryAddress;
        },
        paymentMethodSelected(state, paymentMethodSelected) {
            state.orderPaymentMethod = paymentMethodSelected;
        },
        deliveryMethodSelected(state, orderDeliveryMethod) {
            state.orderDeliveryMethod = orderDeliveryMethod;
        },
        HeaderBottomDisplay(state, HeaderBottomDisplay) {
            state.HeaderBottomDisplay = HeaderBottomDisplay;
        },
        FooterDisplay(state, FooterDisplay) {
            state.FooterDisplay = FooterDisplay;
        },
        cartdisplayActive(state, cartdisplayActive) {
            state.cartdisplayActive = cartdisplayActive;
        },
        personnalInfoDisplayActive(state, personnalInfoDisplayActive) {
            state.personnalInfoDisplayActive = personnalInfoDisplayActive;
        },
        deliveryAddressDisplayActive(state, deliveryAddressDisplayActive) {
            state.deliveryAddressDisplayActive = deliveryAddressDisplayActive;
        },
        deliveryMethodeDisplayActive(state, deliveryMethodeDisplayActive) {
            state.deliveryMethodeDisplayActive = deliveryMethodeDisplayActive;
        },
        paymentDisplayActive(state, paymentDisplayActive) {
            state.paymentDisplayActive = paymentDisplayActive;
        },
        confirmationDisplayActive(state, confirmationDisplayActive) {
            state.confirmationDisplayActive = confirmationDisplayActive;
        },
        checkoutActiveComponent(state, checkoutActiveComponent) {
            state.checkoutActiveComponent = checkoutActiveComponent;
        },
        personnalInfoDisplay(state, personnalInfoDisplay) {
            state.personnalInfoDisplay = personnalInfoDisplay;
        },
        deliveryAddressDisplay(state, deliveryAddressDisplay) {
            state.deliveryAddressDisplay = deliveryAddressDisplay;
        },
        deliveryMethodeDisplay(state, deliveryMethodeDisplay) {
            state.deliveryMethodeDisplay = deliveryMethodeDisplay;
        },
        paymentDisplay(state, paymentDisplay) {
            state.paymentDisplay = paymentDisplay;
        },
        confirmation(state, confirmation) {
            state.confirmation = confirmation;
        },
        personnalInfoComponent(state, personnalInfoComponent) {
            state.personnalInfoComponent = personnalInfoComponent;
        },
        displaySummery(state, displaySummery) {
            state.displaySummery = displaySummery;
        },
        summary(state, summary) {
            state.summary = summary;
        },
        payment_methods(state, payment_methods) {
            state.payment_methods = payment_methods;
        },
        delivery_methods(state, delivery_methods) {
            state.delivery_methods = delivery_methods;
        },
        reset_checkout(state) {

            state.checkoutPaymentMode = 1
            state.checkoutStockStep = 1
            state.checkoutMarketplaceStep = 1
            state.showCartDialog = false
            state.FooterDisplay = true
            state.HeaderBottomDisplay = true
            state.cartdisplayActive = true
            state.personnalInfoDisplayActive = false
            state.deliveryAddressDisplayActive = false
            state.deliveryMethodeDisplayActive = false
            state.paymentDisplayActive = false
            state.confirmationDisplayActive = false
            state.checkoutActiveComponent = undefined
            state.personnalInfoDisplay = true
            state.deliveryAddressDisplay = true
            state.deliveryMethodeDisplay = true
            state.paymentDisplay = true
            state.confirmation = true
            state.FromNameDeliveryAddress = "Delivery Address"
            state.personnalInfoComponent = Signin
            state.displaySummery = true
            state.stepperDisplays = [1, 0, 0, 0, 0, 0]
            state.coupon = {
                    value: undefined,
                }
            state.orderDiscount = 0
            state.orderDeliveryCost = 0
            state.orderEditMode = false
            state.orderId = undefined
            state.payment_methods = []
            state.delivery_methods = []
            state.customer = null
            state.orderDeliveryAddress = {}
            state.orderBillingAddress = {}
            state.orderDeliveryMethod = 1
            state.orderTransferInfo = {}
            state.orderPaymentMethod = 1
            state.deliveryAddressSelected = null
            state.order = null
            state.deposit_amount = null
            state.deposit_paid = false
        },
        [UPDATE_ORDER_Id]: (state, id) => {
            state.orderId = id;
        },
        [GET_BILLING_COMPANY]: (state, data) => {
            state.billingCompany = data;
        },
        [UPDATE_IS_BILLING]: (state, data) => {
            state.is_billing = data;
        },

        [UPDATE_INSURANCE_PERCENTAGE]:(state, data) => {
            state.insurance_percentage = data;
        },
        [UPDATE_DELIVERY_METHOD]: (state, data) => {
            state.orderDeliveryMethod = data;
        },
        [UPDATE_ORDER_DELIVERY_ADDRESS]: (state, data) => {
            state.orderDeliveryAddress = data;
        },
        [UPDATE_ORDER_BILLING_ADDRESS]: (state, data) => {
            state.orderBillingAddress = data;
        },
        [UPDATE_STATUS]: (state, data) => {
            state.status_id = data;
        },
        [UPDATE_DELIVERY_COST]: (state, data) => {
            state.orderDeliveryCost = data == undefined ? 0 : data;
        },
        [UPDATE_DISCOUNT]: (state, data) => {
            state.orderDiscount = data;
        },
        [SWITCH_CART_DIALOG]: (state) => {
            state.showCartDialog = !state.showCartDialog;
        },
        [HIDE_CART_DIALOG]: (state) => {
            state.showCartDialog = false;
        },
        [UPDATE_TRANSFER_INFO]: (state, orderTransferInfo) => {
            state.orderTransferInfo = orderTransferInfo;
        },
        clearCart(state) {
            CookieHelper.setCookie("cartItems", [], 365);
            state.cart.items = [];
        },

        [REMOVE_KIT_FROM_CART]: (state, kit_id) => {
            state.cart.items.forEach(function(item, index) {
                if (item.kit == kit_id) {
                    state.cart.items.splice(index, 1);
                    CookieHelper.setCookie("cartItems", state.cart.items, 365);
                    return;
                }
            });
            state.cart.detailedItems.forEach(function(item, index) {
                if (item.id == kit_id) {
                    state.cart.detailedItems.splice(index, 1);
                    return;
                }
            });
        },

        [ADD_KIT_TO_CART]: (state, data) => {
            var kitExists = false;
            state.cart.items.forEach(function(item) {
                if (item.kit == data.kit.id) {
                    kitExists = true;
                }
            });
            console.log(data.affiliate)
            if (!kitExists) {
                state.cart.items.push({
                    kit: data.kit.id,
                    quantity: data.quantity||data.kit.quantity,
                    affiliate: data.affiliate,
                });
                var items = CookieHelper.getCookie("cartItems");
                if (items == null) {
                    CookieHelper.setCookie("cartItems", [], 365);
                    items = CookieHelper.getCookie("cartItems");
                }
                var j = JSON.parse(items);
                j.push({
                    kit: data.kit.id,
                    quantity: data.quantity||data.kit.quantity,
                    affiliate: data.affiliate,
                });
                CookieHelper.setCookie("cartItems", j, 365);
            }
        },
        [GET_CART_KITS]: (state, kits) => {
            state.cart.detailedItems = kits;
        },
        [ADD_KITS_TO_CART]: (state, kits) => {
            state.cart.items = kits;
        },
        [GET_ORDER_BY_ID]: (state, data) => {
            state.orderBillingAddress = data.order_billing_address;
        },
        [GET_PRICE_BREAKDOWN]: (state, data) => {
            state.cart.detailedItems = data;
        },
    },
    actions: {

        [UPDATE_SELLER_SHIPPING_LOGISTICS]: async(context, data) =>
        {
            var checkoutService = new CheckoutService()

            let result = await checkoutService.update_seller_shipping_logistics(data)
        },

        [GET_SELLER_SHIPPING_LOGISTICS]: async(context, order_kit_id) => {
            var checkoutService = new CheckoutService()
            let result = await checkoutService.get_seller_shipping_logistics(order_kit_id)
            return result
        },

        [GET_BILLING_COMPANY]: async(context) => {
            var checkoutService = new CheckoutService()

            let result = await checkoutService.get_billing_company_by_country_name(context.getters.country)

            context.commit(GET_BILLING_COMPANY, result.data)
        },

        [ADD_KIT_TO_CART]: async(context, data) => {
            var cartService = new CartService();
            var ids = [];
            context.getters.cartItems.forEach(function(item) {
                ids.push(item.kit);
            });
            cartService.confirmAvailability(data.kit)
            if(context.getters.isAuthenticated){
                return cartService
                    .addKitToCartAuthenticated(data, ids, {
                        message: {
                            success: GeneralHelper.buildMessage(1, "Added to the cart !"),
                        },
                    })
                    .then((result) => {
                        result.data.data.affiliate = data.affiliate
                        context.commit(ADD_KIT_TO_CART, result.data.data);
                    })
                    .catch((err) => {
                        console.log(err)
                        if (err.response.status == 432)
                            context.dispatch(
                                SHOW_TOAST_MESSAGE,
                                GeneralHelper.buildMessage(2, "Already added to the cart")
                            );
                    });
                
            }else{
            
                return cartService
                    .addKitToCart(data.kit, ids, {
                        message: {
                            success: GeneralHelper.buildMessage(1, "Added to the cart !"),
                        },
                    })
                    .then((result) => {
                        console.log(result)
                        context.commit(ADD_KIT_TO_CART, {kit:result.data.data, quantity: data.quantity, affiliate: data.affiliate});
                    })
                    .catch((err) => {
                        console.log(err)
                        if (err.response.status == 432)
                            context.dispatch(
                                SHOW_TOAST_MESSAGE,
                                GeneralHelper.buildMessage(2, "Already added to the cart")
                            );
                    });
            }
        },
        [REMOVE_KIT_FROM_CART]: async(context, data) => {
            if(context.getters.isAuthenticated){
                var cartService = new CartService();
                cartService
                .removeKitFromCart(data.kit_id,  {
                    message: {
                        success: GeneralHelper.buildMessage(1, "Removed From Cart!"),
                    },
                })
            }
            context.commit(REMOVE_KIT_FROM_CART, data.kit_id);   
        },
        [ADD_KITS_TO_CART]: (context, kits) => {
            context.commit(ADD_KITS_TO_CART, kits);
        },
        [SWITCH_CART_DIALOG]: (context) => {
            context.commit(SWITCH_CART_DIALOG);
        },
        [GET_CART_KITS]: async(context, kits) => {
            var kitService = new KitService();
            var result = await kitService.getKitList(kits,true);
            context.commit(GET_CART_KITS, result.data.data);
            return result;
        },

        [GET_DELIVERY_COST]: async(context) => {
            var ids = [];
            context.getters.cartItems.forEach(function(item) {
                ids.push(item.kit);
            });
            var data = {
                delivery_address: context.getters.orderDeliveryAddress,
                delivery_method_id: context.getters.orderDeliveryMethod,
                ids: ids,
            };
            var checkoutService = new CheckoutService();
            var result = await checkoutService.getDeliveryCost(data);
            context.commit(UPDATE_DELIVERY_COST, result.data.data.cost);
        },

        [GET_PRICE_BREAKDOWN]: async(context) => {
            var ids = [];

            context.getters.cartItems.forEach(function(item) {
                ids.push(item.kit);
            });
            var data = {
                delivery_address: context.getters.orderDeliveryAddress,
                delivery_method_id: context.getters.orderDeliveryMethod,
                ids: ids,
                order_id: context.getters.orderId,
                payment_method:context.getters.payment_method,
            };
            var checkoutService = new CheckoutService();
            var result = await checkoutService.getPriceBreakdown(data);
            context.commit(GET_PRICE_BREAKDOWN, result.data.data);

            return result;
        },

        [UPDATE_STEPPER]: async(context, list) => {
            let array = {
                cartdisplayActive: 0,
                personnalInfoDisplayActive: 0,
                deliveryAddressDisplayActive: 0,
                deliveryMethodeDisplayActive: 0,
                paymentDisplayActive: 0,
                confirmationDisplayActive: 0,
                displaySummery: 0,
            };

            list.forEach(function(item) {
                array[item]++;
                context.commit(item, true);
            });

            for (const [key, value] of Object.entries(array)) {
                if (value == 0) context.commit(key, false);
            }
        },
        getPaymentMethods: ({ commit }) => {
            return new Promise((resolve, reject) => {
                axios({
                        url: "payment_methods",
                        method: "get",
                    })
                    .then((response) => {
                        commit("payment_methods", response.data.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error.response);
                    });
            });
        },

        cancelOrders:async(context,data)=>{
            var checkoutService = new CheckoutService();
            await checkoutService.cancelOrders(data)
        },
        getWireTransferInfo: async ({ commit }, order_id) => {
            var checkoutService = new CheckoutService();
            var result = await checkoutService.getWireTransferInfo(order_id);
            commit("wireTransferInfo", result.data.data);

        },
        [GET_DELIVERY_METHODS]: async({ commit }) => {
            var deliveryMethodservice = new DeliveryMethodService();
            var result = await deliveryMethodservice.get();
            return result.data;
        },

        createOrder: ({ commit }, data) => {
            return new Promise((resolve, reject) => {
                axios({
                        url: "orders",
                        method: "post",
                        data: data,
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error.response);
                    });
            });
        },
        getShippingAddress: ({ commit }, id) => {
            return new Promise((resolve, reject) => {
                axios({
                        url: "customer/getShippingAddress",
                        method: "post",
                        data: {
                            id: id,
                        },
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error.response);
                    });
            });
        },
        createShippingAddress: ({ commit }, data) => {
            return new Promise((resolve, reject) => {
                axios({
                        url: "customer/createShippingAddress",
                        method: "post",
                        data: data,
                    })
                    .then((response) => {
                        commit("deliveryAddress", response.data.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error.response);
                    });
            });
        },
        [VALIDATE_COUPON]: async(context, data) => {
            var checkoutService = new CheckoutService();

            var kits = [];
            context.getters.cartItems.forEach(function(item) {
                kits.push(item.kit);
            });
            var result = await checkoutService.validateCoupon({
                kits: kits,
                coupon: context.getters.orderCoupon.value,
            });

            context.commit(GET_CART_KITS, result.data.data);

            return result;
        },
        [REDIRECT_TO_PAYMENT]: async({ commit }, data) => {
            var checkoutService = new CheckoutService();
            var result = await checkoutService.payment(data);
            return result;
        },
        [CREATE_STRIPE_SESSION]: async(context) => {
            var stripeService = new StripeService();
            var result = await stripeService.createSession();
            return result.data.data;
        },
        [CREATE_WIRE_PAYMENT]: async(context) => {
            var checkoutService = new CheckoutService();
            var result = await checkoutService.createWireTransaction({
                order_id: context.getters.orderId,
                transfer_reference:context.state.orderTransferInfo.reference,
            });
            return result.data.data;
        },
        [CREATE_CARD_PAYMENT]: async(context, token) => {
            var checkoutService = new CheckoutService();
            var d = {
                customer_id: context.getters.customer.id,
                order_id: context.getters.orderId,
                token: token,
                // number: String(card.num1) +
                //     String(card.num2) +
                //     String(card.num3) +
                //     String(card.num4),
                // name: card.name,
                // cvc: card.cvc,
                // exp_month: parseInt(card.expMonth),
                // exp_year: card.expYear,
            };
            var result = await checkoutService.createCardTransaction(d);
            return result.data.data;
        },
        [EDIT_ORDER]: async(context, data) => {
            var orderId = context.getters.orderId;
            data.id = orderId;
            var orderService = new CheckoutService();
            var result = await orderService.edit(data);
            return result;
        },

        [CREATE_WIRETRANSFER_TRANSACTION]: async(context, reference) => {
            if (context.getters.orderId != undefined) {
                var transactionService = new TransactionService();
                var result = await transactionService.create({
                    customer_id: context.getters.customer.id,
                    reference: reference,
                    order_id: context.getters.orderId,
                    payment_method_id: context.getters.orderPaymentMethod,
                });
                return result;
            }
        },

        [CREATE_CREDIT_CARD]: async(context, card) => {
            var gatewayService = new GatewayService();
            var result = await gatewayService
                .createCard({
                    customer_id: context.getters.customer.id,
                    order_id: context.getters.orderId,
                    num1: card.num1,
                    num2: card.num2,
                    num3: card.num3,
                    num4: card.num4,
                    name: card.name,
                    cvc: card.cvc,
                    expMonth: card.expMonth,
                    expYear: card.expYear,
                })
                .then((result) => {})
                .catch((error) => {});
            return result;
        },

        [CREATE_DEPOSIT]: async(context, card) => {
            if (context.getters.orderId != undefined) {
                var orderService = new CheckoutService();
                var result = await orderService.createDeposit({
                    customer_id: context.getters.customer.id,
                    order_id: context.getters.orderId,
                    number: String(card.num1) +
                        String(card.num2) +
                        String(card.num3) +
                        String(card.num4),
                    name: card.name,
                    cvc: card.cvc,
                    exp_month: card.expMonth,
                    exp_year: card.expYear,
                });
            }
        },

        [CREATE_STRIPE_TRANSACTION]: async(context, reference) => {
            if (context.getters.orderId != undefined) {
                var transactionService = new TransactionService();
                var result = await transactionService.create({
                    customer_id: context.getters.customer.id,
                    reference: reference,
                    order_id: context.getters.orderId,
                    payment_method_id: context.getters.orderPaymentMethod,
                });
                return result;
            }
        },

        [GET_ORDER_BY_ID]: async(context, id) => {
            var checkoutService = new CheckoutService();
            var result = await checkoutService.findById(id);
            context.commit(GET_ORDER_BY_ID, result.data);
            return result;
        },

        [CREATE_ORDER]: async(context) => {
            if (context.getters.orderId == undefined) {
                var customerId = context.getters.customer.id;
                var deliveryAddress = context.getters.orderDeliveryAddress;
                var deliveryMethod = context.getters.orderDeliveryMethod;
                var billingAddress = context.getters.orderBillingAddress;
                var paymentMethod = context.getters.orderPaymentMethod;
                var transferInfo = context.getters.orderTransferInfo;
                var kits = [];
                context.getters.cartItems.forEach(function(item) {
                    kits.push(item);
                });
                var orderService = new CheckoutService();

                var result = await orderService.create({
                    shipping_address: deliveryAddress,
                    delivery_method: deliveryMethod,
                    billing_address: billingAddress,
                    payment_method: paymentMethod,
                    transfer_info: transferInfo,
                    kits: kits,
                    customerId: customerId,
                });
                context.commit(UPDATE_ORDER_Id, result.data.id);
                context.state.orderBillingAddress.id = result.data.billing_address_id
                context.state.orderDeliveryAddress.id = result.data.shipping_address_id
                context.state.is_billing = result.data.is_billing
                context.state.status_id = result.data.status_id
                context.state.invoice_generated = result.data.invoice_generated
                return result;
            }
        },
        [EDIT_ALL_ORDER_DETAILS]: async(context) => {
            if (context.getters.orderId != undefined) {
                var id = context.getters.orderId;
                var customerId = context.getters.customer.id;
                var deliveryAddress = context.getters.orderDeliveryAddress;
                var deliveryMethod = context.getters.orderDeliveryMethod;
                var billingAddress = context.getters.orderBillingAddress;
                var transferInfo = context.getters.orderTransferInfo;
                var is_billing = context.getters.is_billing 
                var status_id = context.getters.status_id
                var payment_method = context.getters.payment_method
                var insurance_percentage = context.getters.insurance_percentage
                var kits = [];
                if(!context.getters.is_dashboard_order&&context.getters.cartItems.length!=0)
                {
                    context.getters.cartItems.forEach(function(item) {
                        kits.push(item);
                    });
                }
                else{
                    context.getters.detailedCartItems.forEach(function(item) {
                        kits.push({kit:item.kit_id});
                    });
                }
                
                var orderService = new CheckoutService();

                var result = await orderService.editOrder({
                    shipping_address: deliveryAddress,
                    delivery_method: deliveryMethod,
                    billing_address: billingAddress,
                    transfer_info: transferInfo,
                    kits: kits,
                    customerId: customerId,
                    id: id,
                    is_billing:is_billing,  
                    payment_method:payment_method,  
                    insurance_percentage: insurance_percentage                
                });
                context.commit(UPDATE_ORDER_Id, result.data.data.id);
                // context.commit('updatePaymentMethod',result.data.data.payment_method_id)
                context.state.orderBillingAddress.id = result.data.data.billing_address_id
                context.state.orderDeliveryAddress.id = result.data.data.shipping_address_id
                context.state.is_billing = result.data.data.is_billing
                context.state.insurance_percentage = result.data.data.insurance_percentage
                context.state.status_id = result.data.data.status_id
                context.state.invoice_generated = result.data.data.invoice_generated
                return result;
            }
        },

        [GET_LATEST_ORDER]: async(context) => {
            var customerId = context.getters.customer.id;

            var orderService = new CheckoutService();

            var result = await orderService.getLatest({
                customerId: customerId
            });
            if(result.data.data)
            {
                context.commit(UPDATE_ORDER_Id, result.data.data.order.id);
                context.commit(UPDATE_ORDER_BILLING_ADDRESS, result.data.data.billing_address);
                context.commit(UPDATE_ORDER_DELIVERY_ADDRESS, result.data.data.shipping_address);
                context.commit(UPDATE_DELIVERY_METHOD, result.data.data.delivery_method.id);
                context.commit(UPDATE_STATUS, result.data.data.order.status_id);
                context.commit(UPDATE_IS_BILLING, result.data.data.order.is_billing);
                context.commit(UPDATE_INSURANCE_PERCENTAGE, result.data.data.order.insurance_percentage);
                context.commit('updatePaymentMethod',result.data.data.order.payment_method_id)
                if(result.data.data.order.is_billing)
                {
                    context.commit(GET_CART_KITS, result.data.data.kits);  
                }
                   
                context.state.invoice_generated = result.data.data.order.invoice_generated
                return result;
                
            }
            else{
                return null
            }

        },
        [GET_DASHBOARD_ORDER_BY_ID]: async(context,id) => {
            context.state.cart.items = [];
            context.state.detailedItems = [];
            var orderService = new CheckoutService();
            var result = await orderService.getOrderById(id);
            if(result.data.data)
            {
                context.commit(UPDATE_ORDER_Id, result.data.data.order.id);
                context.commit(UPDATE_ORDER_BILLING_ADDRESS, result.data.data.billing_address);
                context.commit(UPDATE_ORDER_DELIVERY_ADDRESS, result.data.data.shipping_address);
                context.commit(UPDATE_DELIVERY_METHOD, result.data.data.delivery_method.id);
                context.commit(UPDATE_STATUS, result.data.data.order.status_id);
                context.commit(UPDATE_IS_BILLING, result.data.data.order.is_billing);
                context.commit(UPDATE_INSURANCE_PERCENTAGE, result.data.data.order.insurance_percentage);
                context.commit(GET_CART_KITS, result.data.data.kits);
                context.commit('updatePaymentMethod',result.data.data.order.payment_method_id)
                context.state.invoice_generated = result.data.data.order.invoice_generated
  
                return result;
            }
            else{
                return null
            }
        },
        getDHLDeliveryCost: ({ commit }) => {
            return new Promise((resolve, reject) => {
                axios({
                        method: "get",
                        url: "getDHLCostfunction",
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error.response);
                    });
            });
        },
    },
};